<template>
  <div class="locator__top-bar">
    <div class="locator__top-bar-search">
      <google-autocomplete @keyup.enter.native="findPlace" :placeholder="$t('enter_the_city')"
                           class="locator__search-input" @place_changed="showPlace"
                           v-model="searchInput"
                           :restrictions="autocompleteRestrictions"
      ></google-autocomplete>
      <button v-if="!resetBtn" class="locator__golocalization-btn" @click="findPlace">{{ $t('search') }}</button>
      <button v-if="!resetBtn" class="locator__golocalization-btn locator__golocalization-btn-mobile"
              @click="findPlace">
        <img class="" v-bind:src="getIconLoupe()" alt="">
      </button>
      <button v-if="resetBtn" class="locator__golocalization-btn locator__golocalization-btn--reset"
              @click="mapReset">
        <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="mobile" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"
             stroke-linejoin="round">
            <g id="findOpticZoomList" transform="translate(-325.000000, -105.000000)" stroke="inherit"
               stroke-width="2">
              <g id="Group-2" transform="translate(309.000000, 89.000000)">
                <g id="iconClose2" transform="translate(17.000000, 17.000000)">
                  <path d="M14,0 L0,14" id="Stroke-429"></path>
                  <path d="M14,14 L0,0" id="Stroke-430"></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </button>

    </div>

    <promo-list @promotionSelected="$emit('promotionSelected', $event)"></promo-list>
  </div>
</template>

<script>
    import PromoList from './promo-list'
    import searcherRestrictions from '../langs/searcherRestrictions'

    export default {
        name: "top-bar",
        props: ['map', 'searchValue'],
        data() {
            return {
                placeService: null,
                searchInput: '',
                resetBtn: false
            }
        },
        computed: {
            autocompleteRestrictions() {
                if (this.$appLang && searcherRestrictions[this.$appLang.toLowerCase()]) {
                    return searcherRestrictions[this.$appLang.toLowerCase()]
                }
                return searcherRestrictions['pl']
            }
        },
        watch: {
            map(map) {
                this.placeService = new google.maps.places.PlacesService(map);
            },
            searchInput() {
                this.$emit('update:searchValue', this.searchInput);
                if (this.resetBtn) this.makeBtnAsSearch();
            },
            searchValue(val) {
                this.searchInput = val
                if (!val) this.makeBtnAsSearch()
            }
        },
        components: {
            PromoList,
        },
        methods: {
            mapReset() {
                this.$emit('mapReset');
                this.makeBtnAsSearch();
            },
            showPlace(place) {
                this.$emit('placeSelected', place)
                this.makeBtnAsReset()
                parent.dataLayer.push({
                    'wyszukiwane-haslo': place.name,
                    'event': 'wyszukiwarka'
                });
            },
            findPlace() {
                this.placeService.findPlaceFromQuery(this.getSearchQuery(), (result, status) => {
                    if (google.maps.places.PlacesServiceStatus.OK == status) {
                        this.$emit('placeSelected', result[0])
                        this.makeBtnAsReset()
                        parent.dataLayer.push({
                            'wyszukiwane-haslo': this.searchInput,
                            'event': 'wyszukiwarka'
                        });
                    }
                });
            },
            getSearchQuery() {
                return {
                    query: this.searchInput,
                    fields: ['geometry']
                }
            },
            makeBtnAsReset() {
                this.resetBtn = true;
            },
            makeBtnAsSearch() {
                this.resetBtn = false;
                this.searchInput = ''
            },
          getIconLoupe() {
              if (this.$siteVariantImages[this.$siteVariant] && this.$siteVariantImages[this.$siteVariant]['loupe']) {
                return this.$siteVariantImages[this.$siteVariant]['loupe'];
              }
              return require('../assets/loupe.svg')
          }
        }
    }
</script>

<style lang="scss" scoped>
  .locator__golocalization-btn--reset {
    background: none;
    display: flex;
    align-items: center;
    border: 1px solid #E9E9E9;
    padding: 17px;
  }
</style>
